/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { whenSideBySide, assignFormDesignToCSSVars } from '../fields-customise.style';
import SpecialPropsIndicators from '../props-Indicator/special-props';
import { FormContext } from '../../../shared/contexts/form-context';
import FieldDropdown from '../field-dropdown/field_dropdown';
import { ctrlDefaults } from '../../../../shared/form-lib';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import { getStateValue } from '../../../form/utils';
import {
  ValidationWarning,
  MainChoiceWrapper,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  Field,
} from '../../common-field-styles';

const SelectMultiple = ({ ctrl, inTable, col, tr, formDesign }) => {
  const { inBuilder } = useContext(FormContext);
  const [ctrlValidationError, setCtrlValidationError] = useState(
    getStateValue(ctrl._validationError, col, tr, inTable, inBuilder)
  );

  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];

  useEffect(() => {
    setCtrlValidationError(getStateValue(ctrl._validationError, col, tr, inTable, inBuilder));
  }, [ctrl._validationError, inTable, col, tr]);

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrlValidationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrlValidationError}</ValidationWarning>
        )}

        <Field className={!inBuilder && !inTable ? whenSideBySide(ctrl, formDesign) : ''}>
          {!inTable && (
            <LabelWrapper
              notInBuilder={!inBuilder}
              required={ctrl.props.required}
              className={!inBuilder && !inTable ? whenSideBySide(ctrl, formDesign) : ''}>
              <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }}/>
              <SpecialPropsIndicators ctrl={ctrl} />
            </LabelWrapper>
          )}

          <MainChoiceWrapper
            className={!inBuilder && !inTable ? whenSideBySide(ctrl, formDesign) : ''}
            notInBuilder={!inBuilder}>
            {!inTable && <FieldDropdown options={ctrl.props.options} other={ctrl.props.other} isMultiple ctrl={ctrl} />}

            {inTable && (
              <FieldDropdown
                tr={tr}
                col={col}
                isMultiple
                ctrl={ctrl}
                inTable={inTable}
                options={ctrl.table_props[col - 1].options}
              />
            )}

            {!inTable && (
              <SubtextWrapper id="descriptive text" notInBuilder={!inBuilder}>
                {ctrl.props.subtext}
              </SubtextWrapper>
            )}
          </MainChoiceWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

SelectMultiple.defaultProps = {
  inTable: false,
  col: null,
  tr: null,
  formDesign: null,
};

SelectMultiple.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  inTable: PropTypes.bool,
  col: PropTypes.number,
  tr: PropTypes.number,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default SelectMultiple;
